import { store } from "@store";
import axios from "axios";

import { accessTokenStored } from "../store/token/TokenSlice";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 120000,
});

let isRefreshing = false;
let failedQueue: Array<{
  resolve: (value?: any) => void;
  reject: (reason?: any) => void;
}> = [];

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach(({ resolve, reject }) => {
    if (error) {
      reject(error);
    } else {
      resolve(token);
    }
  });
  failedQueue = [];
};

api.interceptors.request.use((config) => {
  const devToken = process.env.REACT_APP_DEV_TOKEN;
  const access_token = devToken || store.getState().tokenHandling.accessToken;
  config.headers.Authorization = `Bearer ${access_token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(() => {
          return api(originalRequest);
        }).catch((err) => {
          return Promise.reject(err);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        // Usar o UserManager existente para renovar o token
        const userManager = (window as any).userManager;
        if (userManager) {
          const user = await userManager.signinSilent();
          if (user?.access_token) {
            store.dispatch(accessTokenStored(user.access_token));
            processQueue(null, user.access_token);
            return api(originalRequest);
          }
        }
      } catch (refreshError) {
        processQueue(refreshError, null);
        // Limpar tokens e redirecionar
        localStorage.clear();
        window.location.href = '/';
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default api;
